import { Modal } from "antd";
import { useEffect, useRef } from "react";
import { unstable_useBlocker, useBeforeUnload } from "react-router-dom";

const useUnsavedChangesGuard = (dirty) => {
  useBeforeUnload((event) => {
    if (!dirty) return;

    event.preventDefault();
    event.returnValue = "";
  });

  const blocker = unstable_useBlocker(dirty);
  const blockerRef = useRef(blocker);
  blockerRef.current = blocker;

  useEffect(() => {
    if (blocker.state !== "blocked") return undefined;

    const modal = Modal.confirm({
      title: "Leave with unsaved changes?",
      content: "Your unsaved edits will be lost.",
      okText: "Leave page",
      okButtonProps: { danger: true },
      cancelText: "Keep editing",
      onOk: () => blockerRef.current.proceed(),
      onCancel: () => blockerRef.current.reset(),
    });
    return () => modal.destroy();
  }, [blocker.state]);
};

export default useUnsavedChangesGuard;
